import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from './Link';
import SvgDownload from '../../../../play-core/icons/Download';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const Download = ({
  downloads,
  colorSet,
  size,
  className
}) => {
  const {
    t
  } = useTranslation();
  const analytics = useAnalyticsDispatch();
  return downloads?.downloadUrl && /*#__PURE__*/_jsx(Link, {
    to: downloads.downloadUrl,
    onClick: () => {
      analytics({
        type: 'click-event',
        name: 'VideoDownloadClick',
        value1: downloads.urn,
        value2: downloads.show?.urn,
        value3: downloads.show?.title,
        value4: downloads.title
      });
    },
    openInNewTab: true,
    icon: /*#__PURE__*/_jsx(SvgDownload, {}),
    type: "text",
    text: t('global.download'),
    download: true,
    size: size,
    colorSet: colorSet,
    className: className
  });
};